import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    fetchConstributorsBreakdown,
    fetchSkillsBreakdown,
    updateUserStatus
} from 'src/api/community';
import { UserStatus } from 'src/enums/user';

export const SLICE_NAME = 'community';
export const ACTION_TYPES = {
    GET_SKILLS_BREAKDOWN: `${SLICE_NAME}/getCommunitySkillsBreakdown`,
    GET_CONSTRIBUTORS_BREAKDOWN: `${SLICE_NAME}/getCommunityContributorsBreakdown`,
    UPDATE_CONTRIBUTOR_STATUS: `${SLICE_NAME}/updateContributorStatus`
};

export const getSkillsBreakdown = createAsyncThunk(
    ACTION_TYPES.GET_SKILLS_BREAKDOWN,
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchSkillsBreakdown();
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getContributorsBreakdown = createAsyncThunk(
    ACTION_TYPES.GET_CONSTRIBUTORS_BREAKDOWN,
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchConstributorsBreakdown();
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const updateContributorStatus = createAsyncThunk(
    ACTION_TYPES.UPDATE_CONTRIBUTOR_STATUS,
    async (
        params: { userId: string; status: UserStatus },
        { rejectWithValue }
    ) => {
        try {
            await updateUserStatus(params.userId, params.status);
            return params;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const services = {
    getSkillsBreakdown,
    getContributorsBreakdown,
    updateContributorStatus
};

export default services;
